// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1UrJH","footer__content":"Footer_footer__content__1aoEa","link":"Footer_link__1RkDG"};